import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const FeatureGuard = ({ feature, children }) => {
    const { user } = useSelector((state) => state.auth);

    if (user && !user.features?.[feature]) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default FeatureGuard;
